"use client";

import Image, { StaticImageData } from "next/image";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import CommonTitle from "@/components/common/CommonTitle";

export interface GridFeaturesType {
  context: string;
  title: string;
  description: string;
  features: {
    title: string;
    description: string;
    image: StaticImageData;
  }[];
}

const GridFeatures = ({ gridFeatures }: { gridFeatures: GridFeaturesType }) => {
  return (
    <section className="bg-white py-12 xl:py-20">
      <div className="container mx-auto px-4">
        <div className="mb-8 text-center xl:mb-10">
          <div className="mx-auto mb-2 inline-flex w-fit rounded-full bg-[#f3f3f3] px-3 py-1 text-sm font-semibold">
            <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
              {gridFeatures.context}
            </span>
          </div>
          <CommonTitle
            as="h2"
            color="#202020"
            fontSizeClass="text-[24px] lg:text-[32px]"
            fontWeightClass="font-semibold"
            maxWidthClass="mx-auto max-w-6xl"
          >
            {gridFeatures.title}
          </CommonTitle>
          <CommonSubtitle>
            <span className="mx-auto mt-4 block max-w-3xl">
              {gridFeatures.description}
            </span>
          </CommonSubtitle>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {gridFeatures.features.map((feature, index) => (
            <div
              key={index}
              className="rounded-2xl bg-gradient-to-b from-[#F4F1FF] to-white p-4 xl:p-6 h-full"
            >
              <CommonTitle
                as="h3"
                color="#202020"
                fontSizeClass="text-[18px] lg:text-[20px] mb-2"
                fontWeightClass="font-semibold"
              >
                {feature.title}
              </CommonTitle>
              <CommonSubtitle fontSizeWeight="mb-6 min-h-[70px]">
                {feature.description}
              </CommonSubtitle>
              <div className="relative mt-auto">
                <div className="overflow-hidden">
                  <Image
                    src={feature.image}
                    alt={feature.title}
                    className="h-full w-full object-cover"
                    priority={feature.title === "Source-Backed"}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GridFeatures;
